// translations/landing.ts
export const translations = {
    en: {
      'hero.promo': '✨ Try for free - 3 days trial, no credit card required, no auto-renewal ✨',
      'hero.promoMobile': '✨ 3 days free trial ✨',
      'hero.title': 'Convert PDF to XRechnung',
      'hero.titleHighlight': 'in Seconds, Not Hours',
      'hero.titleEnd': '',
      'hero.subtitle': 'AI-powered invoice conversion that saves 95% of your time. Fully compliant with XRechnung standards. Trusted by hundreds of businesses across Europe.',
      'hero.convertNow': 'Convert Invoice Now',
      'hero.signIn': 'Sign In',
      'hero.updates': 'What\'s New',
      'hero.newTitle': 'New: PDF to ZUGFeRD | UBL',
      'hero.newTitleLine2': 'and CII formats',
      'hero.newSubtitle': 'Now supporting ZUGFeRD PDF generation and both UBL and CII XML formats',
      'hero.trustIndicator1': 'Secure & Private',
      'hero.trustIndicator2': '<30 seconds',
      'hero.trustIndicator3': 'German Server',
      'hero.guarantee': '100% money-back guarantee',
      'hero.startFreeConversion': 'Convert First Invoice Free',
      'hero.viewPricing': 'View Pricing',
  
      'features.heading': 'E-Invoicing Solution',
      'features.headingHighlight': 'without system change',
      'features.subtitle': 'Simply convert your existing PDF invoices when needed. No new software required.',
      'features.ai.title': 'Minimal Effort',
      'features.ai.description': 'No complex setup, no learning curve. Simply upload your PDF and get a compliant e-invoice.',
      'features.secure.title': 'Secure & Private',
      'features.secure.description': 'Your data is encrypted and processed in Germany. We never store your invoice data.',
      'features.compliance.title': 'Full Compliance',
      'features.compliance.description': 'Our converter generates fully compliant EN 16931 invoices accepted by all EU authorities.',
      'features.compatibility.title': 'Ready to Submit',
      'features.compatibility.description': 'Convert to XRechnung, ZUGFeRD, UBL, and CII formats. Compatible with all government portals.',
      'features.speed.title': '<30 seconds',
      'features.speed.description': 'Convert your invoices in less than 30 seconds with our AI-powered system.',
      'features.accuracy.title': 'Highest accuracy',
      'features.accuracy.description': 'Our advanced AI ensures near-perfect accuracy in data extraction and conversion.',
      'features.enterprise.title': 'Bulk ready (coming soon)',
      'features.enterprise.description': 'Process multiple invoices at once with our enterprise-grade bulk processing.',
      'features.formats.title': 'All formats (coming soon)',
      'features.formats.description': 'Support for PDF to XRechnung, ZUGFeRD, UBL, and CII formats.',
      'features.support.title': 'Expert support',
      'features.support.description': 'Get help from our expert support team whenever you need it.',
  
      'howItWorks.title': 'How It',
      'howItWorks.titleHighlight': 'Works',
      'howItWorks.steps': [
        {
          step: '1',
          title: 'Upload PDF',
          description: 'Start by uploading your existing PDF invoice'
        },
        {
          step: '2',
          title: 'Automatic Conversion',
          description: 'Our AI processes and converts to EN 16931 XML'
        },
        {
          step: '3',
          title: 'Fact Check',
          description: 'Compare the AI output with the original PDF'
        },
        {
          step: '4',
          title: 'Download XRechnung',
          description: 'Get your compliant XRechnung file instantly'
        }
      ],
  
      'cta.title': 'Stay Compliant & Keep Your Current System',
      'cta.subtitle': 'No expensive software overhaul needed. Simply convert your existing invoices to the required format and stay compliant with German e-invoicing regulations.',
      'cta.button': 'Get Started Now',
  
      'home.pageTitle': 'PDF to XRechnung Converter',
      'home.description': 'Convert PDF invoices to XRechnung and EN 16931 XML format instantly. Compliant with German and EU e-invoicing standards.',
  
      // --- Pricing Section ---
      'pricing.title': 'Pricing',
      'pricing.titleHighlight': 'Plans',
      'pricing.subtitle': 'Choose the plan that fits your needs. First invoice is free.',
      'pricing.annually': 'Annually',
      'pricing.monthly': 'Monthly',
      'pricing.annual': 'Annual',
      'pricing.features': 'Features',
      'pricing.save': 'Save',
      'pricing.yearlyDiscount': '25% off',
      'pricing.yearlyOriginal': 'Originally',
      'pricing.launchOffer': 'Launch Offer',
      'pricing.launchCode': 'Use code: LAUNCH',
      'pricing.launchDesc': 'Get 50% off for the first 3 months',
      'pricing.launchLimit': 'Limited time offer',
      'pricing.cta': 'Get Started',
      'pricing.monthlyPrice': '€20',
      'pricing.perMonth': '/month',
      'pricing.originalPrice': '€12.5/month',
      'pricing.onetime': 'One-time',
      'pricing.onetimePrice': '€5',
      'pricing.onetimeSubtitle': 'Convert a single invoice. No subscription.',
      'pricing.onetimeFeature1': 'Convert single invoice',
      'pricing.onetimeFeature2': 'No subscription',
      'pricing.onetimeFeature3': '100% money-back guarantee',
      'pricing.onetimeCta': 'Convert now',
      'pricing.starter': 'Starter',
      'pricing.starterAnnualPrice': '€12.5',
      'pricing.starterMonthlyPrice': '€20',
      'pricing.starterAnnualNote': '€150 billed annually',
      'pricing.starterMonthlyNote': 'Billed annually',
      'pricing.starterSubtitle': 'For growing businesses',
      'pricing.starterFeature1': 'Unlimited invoice conversions',
      'pricing.starterFeature2': 'Broad support of e-invoicing formats (XRechnung, UBL, CII, ZUGFeRD)',
      'pricing.starterFeature3': 'Priority support',
      'pricing.starterFeature4': '',
      'pricing.starterCta': 'Start free trial',
      'pricing.mostPopular': 'MOST POPULAR',
      'pricing.moneyBackGuarantee': '100% money-back guarantee',
      'pricing.enterprise': 'Enterprise',
      'pricing.enterpriseAnnualPrice': '€20/month',
      'pricing.enterpriseMonthlyPrice': '€12.5/month',
      'pricing.enterpriseAnnualNote': '€240 billed annually',
      'pricing.enterpriseMonthlyNote': 'Billed monthly',
      'pricing.enterpriseSubtitle': 'For high volume & compliance',
      'pricing.enterpriseFeature1': 'Bulk invoice processing',
      'pricing.enterpriseFeature2': 'DPA & compliance',
      'pricing.enterpriseFeature3': 'Dedicated account manager',
      'pricing.enterpriseFeature4': 'Custom onboarding',
      'pricing.enterpriseCta': 'Contact us',
      'pricing.enterpriseContactNote': 'Includes DPA, custom integrations & more',
      'pricing.feature.invoices': 'Invoices per month',
      'pricing.feature.bulk': 'Bulk processing (up to 10 invoices)',
      'pricing.feature.moneyback': '100% money-back guarantee',
      'pricing.feature.enterpriseSupport': 'Enterprise support & DPA / GDPR',
      'pricing.feature.noSubscription': 'No subscription',
      'pricing.value.1invoice': '1',
      'pricing.value.unlimited': 'Unlimited',
      'pricing.value.no': 'Not included',
      'pricing.value.yes': 'Included',
      'pricing.conversion': 'conversion',
      'pricing.billedMonthly': 'Billed monthly',
      
      'stats.invoicesProcessed': 'Invoices Processed',
      'stats.accuracy': 'Accuracy',
      'stats.timeSaved': 'Time Saved',
      
      'demo.title': 'See It in Action',
      'demo.subtitle': 'Watch how easy it is to convert your PDF invoice to XRechnung in 30 seconds',
      
      'problem.title': 'Stop Wasting Hours on Manual Invoice Conversion',
      'problem.point1': 'Manual data entry can take hours per invoice',
      'problem.point2': 'XRechnung compliance deadline approaching fast',
      'problem.point3': 'Errors in manual conversion cause payment delays',
      'problem.point4': 'Expensive enterprise solutions require long contracts',
      
      'solution.title': 'Convert Invoices in Seconds with AI Precision',
      'solution.point1': 'AI extracts all data automatically in 30 seconds',
      'solution.point2': '100% XRechnung-compliant output guaranteed',
      'solution.point3': 'High accuracy verified by hundreds of businesses',
      'solution.point4': 'Pay per invoice – no contracts or setup fees',
      'solution.cta': 'Try Free Conversion',
      
      'whyChooseUs.proven.title': 'Proven Track Record',
      'whyChooseUs.proven.description': 'Thousands of invoices processed successfully',
      'whyChooseUs.speed.title': 'Lightning Fast',
      'whyChooseUs.speed.description': 'Complete conversion in seconds',
      'whyChooseUs.security.title': 'Fully Compliant',
      'whyChooseUs.security.description': 'XRechnung & EN 16931 compliant',
      'whyChooseUs.growth.title': 'Time Savings',
      'whyChooseUs.growth.description': 'Save hours on every invoice',
      
      'howItWorks.subtitle': 'Convert your first invoice in under 30 seconds',
      'howItWorks.cta': 'Start Converting Now',
      
      'finalCta.title': 'Ready to Stop Wasting Time on Manual Conversions?',
      'finalCta.subtitle': 'Join hundreds of businesses who have automated their invoice conversion process. Start with a free conversion today.',
      'finalCta.benefit1': 'First conversion free',
      'finalCta.benefit2': 'Money-back guarantee',
      'finalCta.benefit3': 'Results in 30 seconds',
      'finalCta.primaryButton': 'Convert Your First Invoice Free',
      'finalCta.disclaimer': 'No credit card required for free conversion • Instant results • GDPR compliant',
      
      'faq.showAll': 'Show All FAQs',
    },
    de: {
      'hero.promo': '✨ Kostenlos testen - 3 Tage Testphase, keine Kreditkarte erforderlich, keine automatische Verlängerung ✨',
      'hero.promoMobile': '✨ 3 Tage kostenlos testen ✨',
      'hero.title': 'PDF in XRechnung umwandeln',
      'hero.titleHighlight': 'in Sekunden, nicht Stunden',
      'hero.titleEnd': '',
      'hero.subtitle': 'KI-gestützte Rechnungskonvertierung, die 95% Ihrer Zeit spart. Vollständig konform mit XRechnung-Standards. Vertraut von hunderten Unternehmen in ganz Europa.',
      'hero.convertNow': 'Jetzt Rechnung umwandeln',
      'hero.signIn': 'Anmelden',
      'hero.updates': 'Neuigkeiten',
      'hero.newTitle': 'Neu: PDF zu ZUGFeRD | UBL',
      'hero.newTitleLine2': 'und CII Formate',
      'hero.newSubtitle': 'Jetzt mit ZUGFeRD PDF-Generierung und Unterstützung für UBL und CII XML-Formate',
      'hero.trustIndicator1': 'Sicher & Privat',
      'hero.trustIndicator2': '<30 Sekunden',
      'hero.trustIndicator3': 'Deutsche Server',
      'hero.guarantee': '100% Geld-zurück-Garantie',
      'hero.startFreeConversion': 'Erste Rechnung kostenlos konvertieren',
      'hero.viewPricing': 'Preise ansehen',
  
      'features.heading': 'E-Rechnungslösung',
      'features.headingHighlight': 'ohne Systemwechsel',
      'features.subtitle': 'Konvertieren Sie einfach Ihre bestehenden PDF-Rechnungen bei Bedarf. Keine neue Software erforderlich.',
      'features.ai.title': 'Minimaler Aufwand',
      'features.ai.description': 'Keine komplexe Einrichtung, keine Lernkurve. Laden Sie einfach Ihr PDF hoch und erhalten Sie eine konforme E-Rechnung.',
      'features.secure.title': 'Sicher & Privat',
      'features.secure.description': 'Ihre Daten werden verschlüsselt und in Deutschland verarbeitet. Wir speichern niemals Ihre Rechnungsdaten.',
      'features.compliance.title': 'Volle Konformität',
      'features.compliance.description': 'Unser Konverter generiert vollständig konforme EN 16931 Rechnungen, die von allen EU-Behörden akzeptiert werden.',
      'features.compatibility.title': 'Sofort einreichbar',
      'features.compatibility.description': 'Konvertieren Sie in XRechnung-, ZUGFeRD-, UBL- und CII-Formate. Kompatibel mit allen Behördenportalen.',
      'features.speed.title': '<30 Sekunden',
      'features.speed.description': 'Konvertieren Sie Ihre Rechnungen in weniger als 30 Sekunden mit unserem KI-gestützten System.',
      'features.accuracy.title': 'Höchste Genauigkeit',
      'features.accuracy.description': 'Unsere fortschrittliche KI gewährleistet nahezu perfekte Genauigkeit bei der Datenextraktion und Konvertierung.',
      'features.enterprise.title': 'Massenverarbeitung (demnächst)',
      'features.enterprise.description': 'Verarbeiten Sie mehrere Rechnungen gleichzeitig mit unserer Enterprise-Massenverarbeitung.',
      'features.formats.title': 'Alle Formate (demnächst)',
      'features.formats.description': 'Unterstützung für PDF zu XRechnung, ZUGFeRD, UBL und CII Formate.',
      'features.support.title': 'Experten-Support',
      'features.support.description': 'Erhalten Sie Hilfe von unserem Experten-Support-Team, wann immer Sie sie brauchen.',
  
      'howItWorks.title': 'So',
      'howItWorks.titleHighlight': 'funktioniert\'s',
      'howItWorks.steps': [
        {
          step: '1',
          title: 'PDF hochladen',
          description: 'Laden Sie Ihre PDF-Rechnung hoch'
        },
        {
          step: '2',
          title: 'Automatische Extraktion',
          description: 'Wir extrahieren die Daten automatisch'
        },
        {
          step: '3',
          title: 'Überprüfen',
          description: 'Überprüfen und bearbeiten Sie die Daten bei Bedarf'
        },
        {
          step: '4',
          title: 'XML herunterladen',
          description: 'Erhalten Sie sofort Ihre konforme XML-Datei'
        }
      ],
  
      'cta.title': 'Behalten Sie Ihr aktuelles System & erfüllen Sie Compliance-Anforderungen',
      'cta.subtitle': 'Keine teure Softwareumstellung nötig. Konvertieren Sie einfach Ihre bestehenden Rechnungen in das erforderliche Format und bleiben Sie konform mit deutschen E-Rechnungsvorschriften.',
      'cta.button': 'Jetzt starten',
  
      'home.pageTitle': 'PDF zu XRechnung Konverter',
      'home.description': 'Konvertieren Sie PDF-Rechnungen sofort in XRechnung und EN 16931 XML-Format. Konform mit deutschen und EU-Standards für elektronische Rechnungen.',
  
      // --- Pricing Section ---
      'pricing.title': 'Preise',
      'pricing.titleHighlight': 'Pakete',
      'pricing.subtitle': 'Wählen Sie das passende Paket für Ihre Anforderungen. Erste Rechnung ist kostenlos.',
      'pricing.annually': 'Jährlich',
      'pricing.monthly': 'Monatlich',
      'pricing.annual': 'Jährlich',
      'pricing.features': 'Funktionen',
      'pricing.save': 'Sparen',
      'pricing.yearlyDiscount': '25% Rabatt',
      'pricing.yearlyOriginal': 'Ursprünglich',
      'pricing.launchOffer': 'Einführungsangebot',
      'pricing.launchCode': 'Code: LAUNCH',
      'pricing.launchDesc': '50% Rabatt für die ersten 3 Monate',
      'pricing.launchLimit': 'Zeitlich begrenztes Angebot',
      'pricing.cta': 'Jetzt starten',
      'pricing.monthlyPrice': '20€',
      'pricing.perMonth': '/Monat',
      'pricing.originalPrice': '30€/Monat',
      'pricing.onetime': 'Einmalig',
      'pricing.onetimePrice': '5€',
      'pricing.onetimeSubtitle': 'Eine Rechnung umwandeln. Kein Abo.',
      'pricing.onetimeFeature1': '1 Rechnung konvertieren',
      'pricing.onetimeFeature2': 'Kein Abo',
      'pricing.onetimeFeature3': '100% Geld-zurück-Garantie',
      'pricing.onetimeFeature4': 'Basis-Support',
      'pricing.onetimeCta': 'Jetzt konvertieren',
      'pricing.starter': 'Starter',
      'pricing.starterAnnualPrice': '12,5€',
      'pricing.starterMonthlyPrice': '20€',
      'pricing.starterAnnualNote': '150€ jährlich abgerechnet',
      'pricing.starterMonthlyNote': 'Jährlich abgerechnet',
      'pricing.starterSubtitle': 'Für wachsende Unternehmen',
      'pricing.starterFeature1': 'Unbegrenzte Rechnungsumwandlungen',
      'pricing.starterFeature2': 'Keine Massenverarbeitung',
      'pricing.starterFeature3': 'Priorisierter Support',
      'pricing.starterFeature4': '',
      'pricing.starterCta': 'Kostenlos testen',
      'pricing.mostPopular': 'BELIEBTES PAKET',
      'pricing.moneyBackGuarantee': '100% Geld-zurück-Garantie',
      'pricing.enterprise': 'Enterprise',
      'pricing.enterpriseAnnualPrice': '20€/Monat',
      'pricing.enterpriseMonthlyPrice': '30€/Monat',
      'pricing.enterpriseAnnualNote': '240€ jährlich abgerechnet',
      'pricing.enterpriseMonthlyNote': 'Monatlich abgerechnet',
      'pricing.enterpriseSubtitle': 'Für große Mengen & Compliance',
      'pricing.enterpriseFeature1': 'Massenverarbeitung von Rechnungen',
      'pricing.enterpriseFeature2': 'DPA & Compliance',
      'pricing.enterpriseFeature3': 'Persönlicher Ansprechpartner',
      'pricing.enterpriseFeature4': 'Individuelle Einführung',
      'pricing.enterpriseCta': 'Kontakt aufnehmen',
      'pricing.enterpriseContactNote': 'Inklusive DPA, Integrationen & mehr',
      'pricing.feature.invoices': 'Rechnungen pro Monat',
      'pricing.feature.bulk': 'Massenverarbeitung (bis zu 10 Rechnungen)',
      'pricing.feature.moneyback': '100% Geld-zurück-Garantie',
      'pricing.feature.enterpriseSupport': 'Enterprise-Support & DPA / DSGVO',
      'pricing.feature.noSubscription': 'Kein Abo',
      'pricing.value.1invoice': '1',
      'pricing.value.unlimited': 'Unbegrenzt',
      'pricing.value.no': 'Nicht enthalten',
      'pricing.value.yes': 'Enthalten',
      'pricing.conversion': 'Konvertierung',
      'pricing.billedMonthly': 'Monatlich abgerechnet',
      
      'stats.invoicesProcessed': 'Verarbeitete Rechnungen',
      'stats.accuracy': 'Genauigkeit',
      'stats.timeSaved': 'Zeitersparnis',
      
      'demo.title': 'In Aktion sehen',
      'demo.subtitle': 'Sehen Sie, wie einfach es ist, Ihre PDF-Rechnung in 30 Sekunden in XRechnung zu konvertieren',
      
      'problem.title': 'Schluss mit stundenlanger manueller Konvertierung',
      'problem.point1': 'Manuelle Datenerfassung kann Stunden dauern',
      'problem.point2': 'XRechnung-Compliance-Frist rückt schnell näher',
      'problem.point3': 'Fehler in manueller Konvertierung verursachen Zahlungsverzögerungen',
      'problem.point4': 'Teure Enterprise-Lösungen häufig mit hohem Integrationsaufwand',
      
      'solution.title': 'Konvertieren Sie Rechnungen in Sekunden mit KI-Präzision',
      'solution.point1': 'KI extrahiert alle Daten automatisch in 30 Sekunden',
      'solution.point2': '100% XRechnung-konforme Ausgabe',
      'solution.point3': 'Höchste Genauigkeit in der Praxis',
      'solution.point4': 'Bezahlung pro Rechnung oder flexible Verträge ohne Setup-Gebühren',
      'solution.cta': 'Kostenlose Konvertierung testen',
      
      'whyChooseUs.proven.title': 'Bewährte Erfolgsbilanz',
      'whyChooseUs.proven.description': 'Tausende Rechnungen erfolgreich verarbeitet',
      'whyChooseUs.speed.title': 'Blitzschnell',
      'whyChooseUs.speed.description': 'Vollständige Konvertierung in Sekunden',
      'whyChooseUs.security.title': 'Vollständig konform',
      'whyChooseUs.security.description': 'XRechnung & EN 16931 konform',
      'whyChooseUs.growth.title': 'Zeitersparnis',
      'whyChooseUs.growth.description': 'Sparen Sie Stunden bei jeder Rechnung',
      
      'howItWorks.subtitle': 'Konvertieren Sie Ihre erste Rechnung in unter 30 Sekunden',
      'howItWorks.cta': 'Jetzt mit der Konvertierung beginnen',
      
      'finalCta.title': 'Bereit, keine Zeit mehr mit manuellen Konvertierungen zu verschwenden?',
      'finalCta.subtitle': 'Schließen Sie sich hunderten Unternehmen an, die ihren Rechnungskonvertierungsprozess automatisiert haben. Beginnen Sie heute mit einer kostenlosen Konvertierung.',
      'finalCta.benefit1': 'Erste Konvertierung kostenlos',
      'finalCta.benefit2': 'Geld-zurück-Garantie',
      'finalCta.benefit3': 'Ergebnisse in 30 Sekunden',
      'finalCta.primaryButton': 'Erste Rechnung kostenlos konvertieren',
      'finalCta.disclaimer': 'Keine Kreditkarte für kostenlose Konvertierung erforderlich • Sofortige Ergebnisse • DSGVO-konform',
      
      'faq.showAll': 'Alle FAQs anzeigen',
    }
  };